declare global {
  interface Window {
    fbq: (...args: any[]) => void
    _fbq: (...args: any[]) => void
  }
}

const PIXEL_ID = '2066351794157168'

let initialized = false

export function initMetaPixel() {
  if (initialized || typeof window === 'undefined') return

  // Initialize fbq function
  const n: any = (window.fbq = function () {
    n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments)
  })

  if (!window._fbq) window._fbq = n
  n.push = n
  n.loaded = true
  n.version = '2.0'
  n.queue = []

  // Load the pixel script
  const script = document.createElement('script')
  script.async = true
  script.src = 'https://connect.facebook.net/en_US/fbevents.js'
  const firstScript = document.getElementsByTagName('script')[0]
  firstScript?.parentNode?.insertBefore(script, firstScript)

  // Init pixel
  window.fbq('init', PIXEL_ID)

  initialized = true
}

export function trackPageView() {
  if (typeof window !== 'undefined' && window.fbq) {
    window.fbq('track', 'PageView')
  }
}

export function trackAddToCart() {
  if (typeof window !== 'undefined' && window.fbq) {
    window.fbq('track', 'AddToCart', {
      content_name: 'Protocolo No Estoy Loca',
      content_type: 'product',
      value: 7,
      currency: 'USD',
    })
  }
}
